export const PRELOAD_RELOAD_STORAGE_KEY = "bunker:vite-preload-reload-at";
export const PRELOAD_RELOAD_COOLDOWN_MS = 60_000;

export function createVitePreloadErrorHandler({
  now = () => Date.now(),
  storage = window.sessionStorage,
  reload = () => window.location.reload(),
} = {}) {
  return (event) => {
    const nowMs = now();
    const storedReloadAt = storage.getItem(PRELOAD_RELOAD_STORAGE_KEY);
    const lastReloadAt = storedReloadAt === null ? null : Number(storedReloadAt);

    if (
      lastReloadAt !== null &&
      Number.isFinite(lastReloadAt) &&
      nowMs - lastReloadAt < PRELOAD_RELOAD_COOLDOWN_MS
    ) {
      return;
    }

    event.preventDefault();
    storage.setItem(PRELOAD_RELOAD_STORAGE_KEY, String(nowMs));
    reload();
  };
}

export function registerVitePreloadRecovery(options) {
  const handler = createVitePreloadErrorHandler(options);
  window.addEventListener("vite:preloadError", handler);

  return () => window.removeEventListener("vite:preloadError", handler);
}
